import React, { useState, useEffect } from "react";
import { DialogActions, DialogContent, Dialog } from "@material-ui/core";
// import Button from "@material-ui/core/Button";
import VideoRecorder from "react-video-recorder";
import { postMethod } from "../../api/HTTPServices";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
// import { Backup } from "@material-ui/icons";
// import CircularProgress from "@material-ui/core/CircularProgress";
import LinearProgress from '@material-ui/core/LinearProgress';
// import CameraAltIcon from '@material-ui/icons/CameraAlt';

import VideoCameraFrontIcon from "@mui/icons-material/VideoCameraFront";
import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "@mui/material/IconButton";
import { ErrorData } from "../../helpers";

// import Button from "@mui/material/Button";

const VideoRecorderDialoge = (props) => {
  const [uploadProcess, setUploadProcess] = useState(0);
  const [uploading, setUploading] = useState(false)

  const { AudienceID, closeDialoge, addMessageToList, attachType, roomToken } =
    props;
  const [snackbar, setSnackbar] = useState(false);
  // const [ sendConfirm, setSendConfirm ] = useState(false);
  const [videoBlob, setVideoBlob] = useState();
  const [time, setTime] = useState(-1);
  const [firstClick, setFirstClick] = useState(false);
  const [duration, setDuration] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (!videoBlob) {
        if (firstClick) {
          setTime(time + 1);
        }
        // setTime(time + 1);
      }
    }, 1000);
    return () => clearInterval(intervalId);
  }, [time]);

  useEffect(() => {
    return () => {
      setTime(-1);
    };
  }, [duration]);

  const upLoadVideo = () => {
    // WebM
    // const file = new File([videoBlob], `${Math.random()}.mp4`);
    const file = new File([videoBlob], `${Math.random()}.WebM`);

    if (!videoBlob) {
      return;
    } else {
      setUploading(true)
    }

    let data = new FormData();
    // data.append("file", file);
    data.append("file", videoBlob);

    data.append("audience", AudienceID);
    if (attachType == "prescription") {
      data.append("type", "prescriptionVideoMessage");
    } else {
      data.append("type", "dossierVideoMessage");
    }
    data.append("room_token", roomToken);

    const RequestService = postMethod(
      // "chat",
      // data,
      // "true",
      // "post",
      // "false",
      // "",
      // false,

      "chat",
      data,
      "true",
      "post",
      "false",
      "",
      false,
      (ProgressEvent) => {
        setUploadProcess(
          (ProgressEvent.loaded / ProgressEvent.total) * 100
        );
      },
      () => {
        ErrorData("خطایی در اپلود رخ داد. لطفا مجددا تلاش کنید.");
      },
    );
    RequestService.then(function (response) {
      setUploading(false)
      if (response) {
        setSnackbar(true);
        closeDialoge();
        addMessageToList(response.message);
        // setSendConfirm(false);
      }
    }).catch(e => {
      setUploading(false)
      ErrorData("خطایی در اپلود رخ داد. لطفا مجددا تلاش کنید.");
    })
  };

  const getTime = (e) => {
    const convertToTwoDigitNumber = (input) => {
      return input > 9 ? "" + input : "0" + input;
    };
    const hours = parseInt(e / 60);
    const seconds = e % 60;
    return `${convertToTwoDigitNumber(hours)}:${convertToTwoDigitNumber(
      seconds
    )}`;
  };

  const onStart = () => {
    setFirstClick(true);
    setVideoBlob("");
    setTime(-3);
  };

  const onStop = () => {
    // setTime(-1);
    setDuration(time);
  };
  return (
    <Dialog
      open={true}
      onClose={props.closeDialoge}
      aria-labelledby="form-dialog-title"
    >
      {/* <DialogTitle style={{ textAlign: "center" }}>
        <p className="button_dialog">
          برای ضبط پیام تصویری روی شروع کلیک کنید.
        </p>
      </DialogTitle> */}
      <div className="dialog-header">
        <div className="dialog-header-title">
          <div className="dialog-header-icon">
            <VideoCameraFrontIcon sx={{ fontSize: "30px", margin: "0px" }} />
          </div>
          <h5>ضبط پیام تصویری</h5>
        </div>
        <div className="dialog-header-close">
          <IconButton
            onClick={props.closeDialoge}
            color="error"
            sx={{
              aspectRatio: 1,
              width: "25px",
              height: "25px",
              backgroundColor: "rgb(250, 156, 156)",
            }}
            aria-label="delete"
          >
            <ClearIcon />
          </IconButton>
        </div>
      </div>
      <DialogContent>
        <div className="video_recorder_chat">
          <VideoRecorder
            switchCamera={true}
            mimeType='video/webm;codecs=h264'
            onSwitchCamera={(e) => console.log(e, 'onSwitchCamera')}
            // renderActions={({
            //   onOpenVideoInput,
            //   onTurnOnCamera,
            //   shouldUseVideoInput,
            //   startRecording,
            //   onRecordingComplete,
            // }) =>
            //   shouldUseVideoInput ? (
            //     <Button onClick={onOpenVideoInput} className="button">
            //       Record a video
            //     </Button>
            //   ) : (
            //     <>
            //       <Button onClick={onTurnOnCamera} className="button">
            //         onTurnOnCamera
            //       </Button>

            //       <Button onClick={startRecording} className="button">
            //         record
            //       </Button>

            //       <Button onClick={onRecordingComplete} className="button">
            //         onRecordingComplete
            //       </Button>
            //     </>
            //   )
            // }
            // renderActions={({ status, startRecording, stopRecording, mediaBlobUrl }) => (
            //   <div>
            //     <p>{status}</p>
            //     <button onClick={startRecording}>Start Recording</button>
            //     <button onClick={stopRecording}>Stop Recording</button>
            //     <video src={mediaBlobUrl} controls autoPlay loop />
            //   </div>
            // )}
            // onClick={onStart}
            onStartRecording={onStart}
            onStopRecording={onStop}
            onRecordingComplete={(video) => {
              setVideoBlob(video);
              // upLoadVideo(videoBlob);
            }}
          />
          {!videoBlob && time >= 0 && (
            <div className="video-record-timer">{getTime(time)}</div>
          )}
        </div>
        {duration > 0 && (
          <div className="video-record-duration ">{getTime(duration)}</div>
        )}
      </DialogContent>
      {uploading && (
        <div>
          <LinearProgress
            variant="determinate"
            value={uploadProcess}
            color="primary"
          />
          <p style={{ textAlign: "center", marginTop: "10px" }}>
            درحال بارگذاری...
          </p>
        </div>
      )}
      <DialogActions>
        <div className="space-evenly  v-padding">
          <button disabled={uploading} onClick={upLoadVideo} className="button light">
            <h5>آپلود</h5>
          </button>

          <button onClick={props.closeDialoge} className="button error">
            <h5>لغو ارسال</h5>
          </button>
        </div>
      </DialogActions>

      <Snackbar
        style={{ width: "100%" }}
        open={snackbar}
        autoHideDuration={3000}
        onClose={() => {
          setSnackbar(false);
        }}
      >
        <MuiAlert
          style={{ fontSize: 16, fontFamily: "iranyekan" }}
          severity="success"
          variant="filled"
        >
          پیام تصویری با موفقیت ارسال شد
        </MuiAlert>
      </Snackbar>
      {/* <Dialog open={sendConfirm} onClose={() => setSendConfirm(false)}>
				<DialogTitle className="dialog-text">
					<p>آیا مطمئن هستید؟</p>
				</DialogTitle>
				<DialogActions>
					<Button autoFocus onClose={() => setSendConfirm(false)} color="primary" className="button_dialog">
						انصراف
					</Button>
					<Button onClick={upLoadVideo} color="primary" autoFocus className="button_dialog">
						تایید
					</Button>
				</DialogActions>
			</Dialog> */}
    </Dialog>
  );
};

export default VideoRecorderDialoge;
